import { getSupplierGenericProperties } from '@bridebook/web/app-basic/lib/analytics/helper';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getFairs,
  getIsVenue,
  getSupplier,
  getSupplierTier,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import LocationContactDetailsComp from '@bridebook/web/app-basic/components/supplier/sections/location-contact-details/location-contact-details';
import { IShowPhoneProps } from '@bridebook/web/app-basic/components/supplier/sections/location-contact-details/contact-details-bar/show-phone';
import { TLoggedOutPageClickedSection } from '@bridebook/web/app-shared/lib/types';
import { useSupplierAccordion } from '../hooks/use-supplier-accordion';
import ToggleEnquiryFormButton from '../toggle-enquiry-form-button';

const LocationContactDetails = () => {
  const supplier = useSelector(getSupplier);
  const isVenue = useSelector(getIsVenue);
  const isTablet = useSelector(getIsTablet);
  const isMobile = useSelector(getIsMobile);
  const fairs = useSelector(getFairs);
  const accordionProps = useSupplierAccordion();
  const dispatch = useDispatch();
  const supplierTier = useSelector(getSupplierTier);
  const supplierGenericProps = useMemo(
    () => getSupplierGenericProperties({ supplier, supplierTier }),
    [supplier, supplierTier],
  );

  const loggedOutAnalytics = useCallback(
    (cta: string, clickedSection: TLoggedOutPageClickedSection) => {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'supplierProfile',
          clickedSection,
          cta,
          ...supplierGenericProps,
        }),
      );
    },
    [dispatch, supplierGenericProps],
  );

  const onSocialMediaClick = useCallback(
    (title: string) => {
      loggedOutAnalytics(title, 'supplierSocialMedia');
    },
    [loggedOutAnalytics],
  );

  const onWebsiteClick = useCallback(() => {
    loggedOutAnalytics('website', 'contactDetails');
  }, [loggedOutAnalytics]);

  if (!supplier) return null;

  const enquiryFormButton = !isVenue ? (
    <ToggleEnquiryFormButton fixedWidth={343} contactMethod="supplierProfile_location" />
  ) : null;

  const phoneProps: IShowPhoneProps = {
    isCordova: false,
    isMobile,
    supplier,
    useSignupLink: true,
  };

  return (
    <LocationContactDetailsComp
      accordionProps={accordionProps}
      enquiryFormButton={enquiryFormButton}
      fairs={fairs}
      isLandscape={false}
      isMobile={isMobile}
      isTablet={isTablet}
      openStatic
      phoneProps={phoneProps}
      supplier={supplier}
      supplierTier={supplierTier}
      isLoggedIn={false}
      onSocialMediaClick={onSocialMediaClick}
      onWebsiteClick={onWebsiteClick}
      noSocial={isVenue}
      isVenue={isVenue}
    />
  );
};

export default LocationContactDetails;
